import {css} from '@emotion/css';
import {
  CategoriesDb,
  CustomerItem,
  CustomerPortalItemsTab,
  customerItemPreviousResaleTypeBadge,
} from '@remoov/functional';
import {theme} from '@remoov/remoov-components';
import {complement, equals, last, propEq} from 'ramda';
import React from 'react';
import {
  ItemsBoardContainer,
  ItemsBoardHeader,
  ItemsBoardLeftContainer,
  ItemsBoardRightContainer,
  ItemsBoardRowWithActionIcon,
  ItemsBoardTitle,
} from '../Common';
import {DonationBoardItem} from '../DonationBoardItem';
import {ItemDetailsModal} from '../ItemDetailsModal';
import downArrow from './downarrow.svg';
import upArrow from './uparrow.svg';

export type DonationBoardProps = {
  items: CustomerItem[];
  itemTab: Extract<CustomerPortalItemsTab, 'donation' | 'recycle'>;
  isOpenModal: Maybe<number>;
  setIsOpenModal: (itemId: Maybe<number>) => unknown;
  sort: string;
  sortDirection: 'asc' | 'desc';
  setSort: (column: string) => unknown;
};

const findCategoryName = (categoryId: Maybe<number>) => {
  const fullname = CategoriesDb.find(propEq('id', categoryId))?.name || 'Other';

  return last(fullname.split(' > ').filter(complement(equals('Other')))) || 'Other';
};

export const DonationBoard = ({
  items,
  itemTab,
  isOpenModal,
  setIsOpenModal,
  sort,
  sortDirection,
  setSort,
}: DonationBoardProps) => (
  <ItemsBoardContainer>
    <ItemsBoardHeader>
      <ItemsBoardLeftContainer
        className={css({marginLeft: '194px', padding: `${theme.spacings.xsmall} 0`})}
      >
        <ItemsBoardRowWithActionIcon onClick={() => setSort('category')}>
          <ItemsBoardTitle>CATEGORY</ItemsBoardTitle>
          {sort !== 'category' ? null : sortDirection === 'asc' ? (
            <img src={upArrow} alt='crescent sort' />
          ) : (
            <img src={downArrow} alt='decrescent sort' />
          )}
        </ItemsBoardRowWithActionIcon>
      </ItemsBoardLeftContainer>
      <ItemsBoardRightContainer className={css({margin: `${theme.spacings.xsmall} 0`})}>
        <ItemsBoardRowWithActionIcon onClick={() => setSort('quantity')}>
          <ItemsBoardTitle>QUANTITY</ItemsBoardTitle>
          {sort !== 'quantity' ? null : sortDirection === 'asc' ? (
            <img src={upArrow} alt='crescent sort' />
          ) : (
            <img src={downArrow} alt='decrescent sort' />
          )}
        </ItemsBoardRowWithActionIcon>
      </ItemsBoardRightContainer>
    </ItemsBoardHeader>
    {items.map(item => (
      <>
        <DonationBoardItem
          imgUrl={item.small_url || ''}
          alt={item.material || ''}
          category={findCategoryName(item.item_category_id)}
          quantity={item.quantity || 0}
          resaleTypeBadge={customerItemPreviousResaleTypeBadge(itemTab, item.status)}
          onClick={() => setIsOpenModal(item.id)}
        />
        {isOpenModal === item.id && (
          <ItemDetailsModal
            isOpen={isOpenModal === item.id}
            setIsOpen={newIsOpen => (newIsOpen ? setIsOpenModal(item.id) : setIsOpenModal(null))}
            code={item.barcode || ''}
            imgUrl={item.big_url || ''}
            imgAlt={item.material || ''}
            category={item.item_category_id || ''}
            brand={item.brand || ''}
            original_price={item.original_price || ''}
          />
        )}
      </>
    ))}
  </ItemsBoardContainer>
);
